/**
 * Snippets API
 * Here is the API DNA
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PredictionSerializerUpdate {
  readonly id?: number;
  value?: string;
  readonly formattedValue?: string;
  readonly score?: number;
  startIndex?: number;
  endIndex?: number;
  coordinates?: any;
  main?: boolean;
  readonly group?: string;
  readonly userCreated?: boolean;
  status?: PredictionSerializerUpdate.StatusEnum;
  readonly entity?: string;
  readonly _var?: number;
  readonly doc?: number;
  readonly parent?: number;
}
export namespace PredictionSerializerUpdate {
  export type StatusEnum = 'PENDING' | 'CORRECT' | 'INCORRECT';
  export const StatusEnum = {
    PENDING: 'PENDING' as StatusEnum,
    CORRECT: 'CORRECT' as StatusEnum,
    INCORRECT: 'INCORRECT' as StatusEnum,
  };
}
